export enum ImageCategoryEnum {
    HOARDING = 'hoardings',
    HOARDING_GROUP = 'hoarding-groups',
    KIOSK = 'kiosks'
}